<template>
  <svg width="23" height="29" viewBox="0 0 23 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="21.6904"
      y="4.5"
      width="23.5569"
      height="17.1903"
      rx="1.5"
      transform="rotate(90 21.6904 4.5)"
      stroke="#828282" />
    <path
      d="M16.1895 0C17.2939 4.82784e-08 18.1893 0.895553 18.1895 2V22.5576C18.1892 23.662 17.2939 24.5576 16.1895 24.5576H2C0.89558 24.5576 0.000243841 23.662 0 22.5576V2C0.000144294 0.895553 0.895519 -4.82784e-08 2 0H16.1895ZM9.09473 1.81934C8.61964 1.81951 8.22913 2.18386 8.18848 2.64844C8.18463 2.69244 8.14964 2.72852 8.10547 2.72852H6.82129C6.57013 2.72852 6.36621 2.93244 6.36621 3.18359C6.36641 3.43458 6.57025 3.6377 6.82129 3.6377H9.07617C9.08232 3.63783 9.08855 3.63867 9.09473 3.63867C9.10079 3.63866 9.10725 3.63781 9.11328 3.6377H11.3682C11.6192 3.63765 11.823 3.43456 11.8232 3.18359C11.8232 2.93247 11.6193 2.72856 11.3682 2.72852H10.085C10.0408 2.72852 10.0048 2.69244 10.001 2.64844C9.96022 2.18381 9.56991 1.81938 9.09473 1.81934Z"
      fill="#FB6C53" />
    <g clip-path="url(#clip0_2001_4825)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2124 9.34725C10.4776 9.03984 10.6564 8.61168 10.6075 8.18567C10.2252 8.20022 9.7628 8.42984 9.48873 8.73688C9.24262 9.00937 9.02778 9.44476 9.08554 9.86241C9.51191 9.89406 9.94711 9.65503 10.2124 9.34725ZM11.1685 12.0511C11.1791 13.1523 12.1765 13.5187 12.1875 13.5234C12.1794 13.5492 12.0282 14.0454 11.6622 14.5583C11.3454 15.0014 11.0169 15.4427 10.4993 15.4522C9.99089 15.4613 9.82718 15.1634 9.24557 15.1634C8.66432 15.1634 8.48259 15.4427 8.0014 15.4613C7.50182 15.4791 7.12106 14.9818 6.80211 14.5402C6.1495 13.6369 5.65102 11.9875 6.32056 10.8742C6.65312 10.3216 7.24725 9.97115 7.89251 9.96242C8.38289 9.95333 8.84605 10.2786 9.14587 10.2786C9.44569 10.2786 10.0085 9.88753 10.6001 9.94501C10.8477 9.95483 11.543 10.0407 11.9892 10.6668C11.9532 10.6882 11.1596 11.1307 11.1685 12.0511Z"
        fill="#232323" />
    </g>
    <defs>
      <clipPath id="clip0_2001_4825">
        <rect
          width="7.27612"
          height="7.27612"
          fill="white"
          transform="translate(5.45709 8.18567)" />
      </clipPath>
    </defs>
  </svg>
</template>
